// extracted by mini-css-extract-plugin
export default {"image":"P1-z","loaded":"Q1-z"};